export default (form, languages) => {
	const body = { data: {} };
	body.id = form.id;
	languages.forEach((lang) => {
		body.data[lang.uuid] = {
			name: form[`${lang.uuid}-name`],
		};
	});

	return body;
};



// WEBPACK FOOTER //
// ./src/helpers/formatFaqCatUpdateBody.js